module.exports = __webpack_public_path__ + "static/img/top-img3.b8df238.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top-img3.png
// module id = TDHR
// module chunks = 0